import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

// Helper to flatten subtopics map into an array for navigation state
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const TOCModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Proof Techniques', path: '/TOC-ProofTechniques' },
      { name: 'LANGUAGES AND GRAMMAR IN TOC', path: '/TOC-Languages' },
      { name: 'ALPHABETS,STRINGS,OPERATION ON LANGUAGES', path: '/TOC-Alphabets' },
      { name: 'Summary', path: '/TOCMO1-Summary' }
    ],
    'Module 2': [
      { name: 'FINITE AUTOMATA', path: '/TOC-FiniteAutomata' },
      { name: 'NON-DETERMINISTIC FINITE AUTOMATA (NFA)', path: '/TOC-NFA' },
      { name: 'DETERMINISTIC FINITE AUTOMATA (DFA)', path: '/TOC-DFA' },
      { name: 'CONVERSION OF NFA WITH EPSILON TO NFA WITHOUT EPSILON', path: '/TOC-NFAConversion' },
      { name: 'NFA TO DFA CONVERSION', path: '/TOC-NFAtoDFA' },
      { name: 'MINIMIZATION OF DFA', path: '/TOC-MinimizationDFA' },
      { name: 'MODULE SUMMARY', path: '/TOC-ModuleSummary' }


    ],
    'Module 3': [
      { name: 'REGULAR EXPRESSIONS', path: '/TOC-RegularExpressions' },
      { name: 'FINITE AUTOMATA TO REGULAR EXPRESSION', path: '/TOC-FAtoRE' },
      { name: 'REGULAR EXPRESSION TO FINITE AUTOMATA', path: '/TOC-REtoFA' },
      { name: 'PUMPING LEMMA & CLOSURE PROPERTIES', path: '/TOC-PumpingLemma' },


    ],
    'Module 4': [
      { name: 'CONTEXT-FREE GRAMMAR (CFG)', path: '/TOC-CFG' },
      { name: 'DERIVATIONS - PARSE TREES - AMBIGUITY IN CFG', path: '/TOC-Derivations' },
      { name: 'CYK ALGORITHM', path: '/TOC-CYK' },
      { name: 'SIMPLIFICATION OF CFG – ELIMINATION OF USELESS SYMBOLS, UNIT PRODUCTIONS, NULL PRODUCTIONS', path: '/TOC-SimplificationCFG' },
      { name: 'NORMAL FORMS FOR CFG: CNF AND GNF', path: '/TOC-NormalFormsCFG' },
      { name: 'PUMPING LEMMA FOR CFL', path: '/TOC-PumpingLemmaCFL' },
      { name: 'CLOSURE PROPERTIES OF CFL', path: '/TOC-ClosurePropertiesCFL' },
    ],
    'Module 5': [
      { name: 'Pushdown Automata (PDA)', path: '/TOC-PDA' },
      //later part {name: 'NPDA and DPDA',path: '/TOC-NPDA-DPDA',},
    ],
    'Module 6': [
      //  { name: 'Soon...', path: '/module6-subtopic1' },
      //  { name: 'Soon...', path: '/module6-subtopic2' },
      //  { name: 'Soon...', path: '/module6-subtopic3' }
    ],
    'Module 7': [
      //  { name: 'Soon...', path: '/module7-subtopic1' },
      //  { name: 'Soon...', path: '/module7-subtopic2' },
      //  { name: 'Soon...', path: '/module7-subtopic3' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  // Flattened list passed to subtopic pages so they can render navigation
  const allSubtopics = getAllSubtopics(subtopicsData);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Theory of Computation </h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module].map((topic, index) => (
                  <li key={index}>
                    <span>{topic.name}</span>
                    <Link
                      to={topic.path}
                      className="article-link"
                      state={{ subtopics: allSubtopics, subjectPath: '/subject-TOCModules' }}
                    >
                      <FontAwesomeIcon icon={faFileAlt} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TOCModules;
